// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-content {
  padding: 20px 30px;
  border-radius: 12px;
  text-align: center;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  color: #111;
   max-height:80vh;
  overflow-y:auto;

  /* Hide Scrollbar */
  scrollbar-width: none;        /* Firefox */
  -ms-overflow-style: none; 
}

.modal-box::-webkit-scrollbar{
  display:none;                 /* Chrome, Safari */
}

/* Table ko compact banane ke liye */
.category-container table {
  border-collapse: collapse;
  width: 100%;
}

.category-container th,
.category-container td {
  padding: 6px 10px;
  /* 👈 pehle zyada hota hai, ab kam */
  font-size: 14px;
  /* 👈 font thoda chota */
  line-height: 1.2;
}

.category-container tr {
  height: 36px;
  /* 👈 row height kam kar di */
}

.category-container thead th {
  font-weight: 600;
}

/* Status badge ko bhi compact kar do */
.status-badge {
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 12px;
  display: inline-block;
  font-weight: 500;
}

/* Pending - Yellow */
.status-badge.pending {
  background-color: #fff3cd;
  color: #856404;
}

/* Approved - Green */
.status-badge.approved {
  background-color: #d4edda;
  color: #155724;
}

/* Rejected - Red */
.status-badge.rejected {
  background-color: #f8d7da;
  color: #721c24;
}
.compact-table th,
.compact-table td {
  padding: 6px 10px;
  font-size: 14px;
}

.compact-table tr {
  height: 36px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  /* 👈 right align */
  align-items: center;
  margin-top: 15px;
  gap: 10px;
}

.pagination button {
  padding: 6px 12px;
  border: 1px solid #ccc;
  background: #f4f4f4;
  cursor: pointer;
  border-radius: 5px;
}

.pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.pagination span {
  font-weight: 500;
}

/* Table.css me add karein */
.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;   /* buttons ke beech gap */
}

.icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 6px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background: transparent;
}

.action-btn.edit {
  background-color: #007bff;
  color: white;
}

.action-btn.edit:hover {
  background-color: #0056b3;
}

/* Delete Modal Styles */
.delete-modal {
  max-width: 400px;
  text-align: center;
}

.delete-modal h3 {
  color: #dc3545;
  margin-bottom: 15px;
}

.delete-modal p {
  margin: 10px 0;
  color: #333;
}

.delete-modal .warning-text {
  color: #dc3545;
  font-size: 14px;
  font-style: italic;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
}

.cancel-btn {
  padding: 8px 20px;
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.cancel-btn:hover {
  background-color: #5a6268;
}

.delete-confirm-btn {
  padding: 8px 20px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.delete-confirm-btn:hover {
  background-color: #c82333;
}

/* Action Buttons */
.action-btn.delete {
  background-color: #dc3545;
  color: white;
}

.action-btn.delete:hover {
  background-color: #c82333;
}
/* Toast Message Styles - Exactly like your image upload */
.toast-message {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  z-index: 1000;
  animation: slideIn 0.3s ease-in-out;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.toast-message.success {
  background-color: #4caf50;
  color: white;
}

.toast-message.error {
  background-color: #f44336;
  color: white;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Optional: Auto hide animation */
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.toast-message.hiding {
  animation: fadeOut 0.3s ease-in-out;
}
.status-dropdown{
  background:#1e1e1e;
  color:#fff;
  border:1px solid #444;
  padding:6px 10px;
  border-radius:4px;
}
.update-btn {
  background-color: #007bff; /* blue */
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  margin-right: 10px;
  font-size: 14px;
}

.update-btn:hover {
  background-color: #0056b3;
}

.close-btnn {
  background-color: #ffc107; /* yellow */
  color: black;
  border: none;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

.close-btn:hover {
  background-color: #e0a800;
}

.status-pill {
  border: none;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.status-pill.active {
  background: #dcfce7;
  color: #166534;
}

.status-pill.inactive {
  background: #fee2e2;
  color: #991b1b;
}

/* Approval status */
.status-badge {
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  text-transform: capitalize;
}

.status-badge.pending {
  background: #fef9c3;
  color: #854d0e;
}

.status-badge.approved {
  background: #dcfce7;
  color: #166534;
}

.status-badge.rejected {
  background: #fee2e2;
  color: #991b1b;
}
.filters-row {
  display: flex;
  gap: 10px;
  flex: 1 1;
  align-items: center;
}

/* All same size */
.filter-input,
.filter-select {
  flex: 1 1;
  min-width: 180px;
  max-width: 200px;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #2c3e50;
  background-color: #0f172a;
  color: white;
}

/* Placeholder */
.filter-input::placeholder {
  color: #94a3b8;
}

/* Responsive */
@media (max-width: 768px) {
  .filters-row {
    flex-wrap: wrap;
  }
}

.filter-wrapper {
  display: flex;
  justify-content: flex-start; /* left side */
  align-items: center;
  gap: 12px;
  flex-wrap: wrap; /* mobile responsive */
}

.filter-input,
.filter-select {
  height: 38px;
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  outline: none;
}

.product-img {
  width: 55px;
  height: 55px;
  object-fit: cover;          /* image stretch nahi hogi */
  border-radius: 8px;         /* thoda smooth look */
  border: 1px solid #e5e7eb;  /* light border */
  padding: 2px;
  background: #fff;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

/* 🔥 Hover effect (premium feel) */
.product-img:hover {
  transform: scale(1.15);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  z-index: 10;
  position: relative;
}
/* Gallery Modal Styles */
.gallery-modal .gallery-content {
  background: #1e1e1e;
  border-radius: 12px;
  max-width: 90vw;
  max-height: 58vh;
  position: relative;
  padding: 20px;
}

.gallery-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: all 0.3s;
}

.gallery-close:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}

.gallery-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  min-height: 60vh;
}

.gallery-nav {
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.gallery-nav:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}

.gallery-nav:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.gallery-image-wrapper {
  position: relative;
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.gallery-image {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
}

.image-counter {
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
}

.thumbnail-container {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 50px;
  padding: 10px;
  overflow-x: auto;
}

.thumbnail {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s;
}

.thumbnail:hover {
  transform: scale(1.05);
  border-color: #007bff;
}

.thumbnail.active {
  border-color: #007bff;
  box-shadow: 0 0 10px rgba(0, 123, 255, 0.5);
}

/* For better mobile responsiveness */
@media (max-width: 768px) {
  .gallery-nav {
    width: 35px;
    height: 35px;
  }
  
  .gallery-nav svg {
    width: 24px;
    height: 24px;
  }
  
  .thumbnail {
    width: 45px;
    height: 45px;
  }
  
  .gallery-content {
    padding: 15px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/Products/ProductList/ProductList.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,yCAAyC;EACzC,WAAW;GACV,eAAe;EAChB,eAAe;;EAEf,mBAAmB;EACnB,qBAAqB,SAAS,YAAY;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,YAAY,kBAAkB,mBAAmB;AACnD;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,IAAI,yBAAyB;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA,0DAA0D;AAC1D;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yBAAyB,EAAE,SAAS;EACpC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,WAAW;EACtC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;;EAEE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B,EAAE,cAAc;EAC3C,mBAAmB;EACnB,SAAS;EACT,eAAe,EAAE,sBAAsB;AACzC;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,WAAW,4BAA4B;EACxD,kBAAkB,UAAU,sBAAsB;EAClD,yBAAyB,GAAG,iBAAiB;EAC7C,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,sBAAsB;EACtB,yCAAyC;EACzC,WAAW;EACX,kBAAkB;AACpB;AACA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,qCAAqC;AACrC;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.modal-content {\n  padding: 20px 30px;\n  border-radius: 12px;\n  text-align: center;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  color: #111;\n   max-height:80vh;\n  overflow-y:auto;\n\n  /* Hide Scrollbar */\n  scrollbar-width: none;        /* Firefox */\n  -ms-overflow-style: none; \n}\n\n.modal-box::-webkit-scrollbar{\n  display:none;                 /* Chrome, Safari */\n}\n\n/* Table ko compact banane ke liye */\n.category-container table {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.category-container th,\n.category-container td {\n  padding: 6px 10px;\n  /* 👈 pehle zyada hota hai, ab kam */\n  font-size: 14px;\n  /* 👈 font thoda chota */\n  line-height: 1.2;\n}\n\n.category-container tr {\n  height: 36px;\n  /* 👈 row height kam kar di */\n}\n\n.category-container thead th {\n  font-weight: 600;\n}\n\n/* Status badge ko bhi compact kar do */\n.status-badge {\n  padding: 3px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  display: inline-block;\n  font-weight: 500;\n}\n\n/* Pending - Yellow */\n.status-badge.pending {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n/* Approved - Green */\n.status-badge.approved {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n/* Rejected - Red */\n.status-badge.rejected {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n.compact-table th,\n.compact-table td {\n  padding: 6px 10px;\n  font-size: 14px;\n}\n\n.compact-table tr {\n  height: 36px;\n}\n\n.pagination {\n  display: flex;\n  justify-content: flex-end;\n  /* 👈 right align */\n  align-items: center;\n  margin-top: 15px;\n  gap: 10px;\n}\n\n.pagination button {\n  padding: 6px 12px;\n  border: 1px solid #ccc;\n  background: #f4f4f4;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.pagination button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.pagination span {\n  font-weight: 500;\n}\n\n/* Table.css me add karein */\n.action-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;   /* buttons ke beech gap */\n}\n\n.icon-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 6px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  background: transparent;\n}\n\n.action-btn.edit {\n  background-color: #007bff;\n  color: white;\n}\n\n.action-btn.edit:hover {\n  background-color: #0056b3;\n}\n\n/* Delete Modal Styles */\n.delete-modal {\n  max-width: 400px;\n  text-align: center;\n}\n\n.delete-modal h3 {\n  color: #dc3545;\n  margin-bottom: 15px;\n}\n\n.delete-modal p {\n  margin: 10px 0;\n  color: #333;\n}\n\n.delete-modal .warning-text {\n  color: #dc3545;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.cancel-btn {\n  padding: 8px 20px;\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s;\n}\n\n.cancel-btn:hover {\n  background-color: #5a6268;\n}\n\n.delete-confirm-btn {\n  padding: 8px 20px;\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s;\n}\n\n.delete-confirm-btn:hover {\n  background-color: #c82333;\n}\n\n/* Action Buttons */\n.action-btn.delete {\n  background-color: #dc3545;\n  color: white;\n}\n\n.action-btn.delete:hover {\n  background-color: #c82333;\n}\n/* Toast Message Styles - Exactly like your image upload */\n.toast-message {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  padding: 12px 24px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  z-index: 1000;\n  animation: slideIn 0.3s ease-in-out;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.toast-message.success {\n  background-color: #4caf50;\n  color: white;\n}\n\n.toast-message.error {\n  background-color: #f44336;\n  color: white;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* Optional: Auto hide animation */\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.toast-message.hiding {\n  animation: fadeOut 0.3s ease-in-out;\n}\n.status-dropdown{\n  background:#1e1e1e;\n  color:#fff;\n  border:1px solid #444;\n  padding:6px 10px;\n  border-radius:4px;\n}\n.update-btn {\n  background-color: #007bff; /* blue */\n  color: white;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  margin-right: 10px;\n  font-size: 14px;\n}\n\n.update-btn:hover {\n  background-color: #0056b3;\n}\n\n.close-btnn {\n  background-color: #ffc107; /* yellow */\n  color: black;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.close-btn:hover {\n  background-color: #e0a800;\n}\n\n.status-pill {\n  border: none;\n  padding: 4px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.status-pill.active {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.status-pill.inactive {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* Approval status */\n.status-badge {\n  padding: 3px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  text-transform: capitalize;\n}\n\n.status-badge.pending {\n  background: #fef9c3;\n  color: #854d0e;\n}\n\n.status-badge.approved {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.status-badge.rejected {\n  background: #fee2e2;\n  color: #991b1b;\n}\n.filters-row {\n  display: flex;\n  gap: 10px;\n  flex: 1;\n  align-items: center;\n}\n\n/* All same size */\n.filter-input,\n.filter-select {\n  flex: 1;\n  min-width: 180px;\n  max-width: 200px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  border: 1px solid #2c3e50;\n  background-color: #0f172a;\n  color: white;\n}\n\n/* Placeholder */\n.filter-input::placeholder {\n  color: #94a3b8;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .filters-row {\n    flex-wrap: wrap;\n  }\n}\n\n.filter-wrapper {\n  display: flex;\n  justify-content: flex-start; /* left side */\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap; /* mobile responsive */\n}\n\n.filter-input,\n.filter-select {\n  height: 38px;\n  padding: 6px 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  outline: none;\n}\n\n.product-img {\n  width: 55px;\n  height: 55px;\n  object-fit: cover;          /* image stretch nahi hogi */\n  border-radius: 8px;         /* thoda smooth look */\n  border: 1px solid #e5e7eb;  /* light border */\n  padding: 2px;\n  background: #fff;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n}\n\n/* 🔥 Hover effect (premium feel) */\n.product-img:hover {\n  transform: scale(1.15);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  z-index: 10;\n  position: relative;\n}\n/* Gallery Modal Styles */\n.gallery-modal .gallery-content {\n  background: #1e1e1e;\n  border-radius: 12px;\n  max-width: 90vw;\n  max-height: 58vh;\n  position: relative;\n  padding: 20px;\n}\n\n.gallery-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: rgba(0, 0, 0, 0.5);\n  border: none;\n  color: white;\n  cursor: pointer;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n  transition: all 0.3s;\n}\n\n.gallery-close:hover {\n  background: rgba(0, 0, 0, 0.8);\n  transform: scale(1.1);\n}\n\n.gallery-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  min-height: 60vh;\n}\n\n.gallery-nav {\n  background: rgba(0, 0, 0, 0.5);\n  border: none;\n  color: white;\n  cursor: pointer;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s;\n}\n\n.gallery-nav:hover:not(:disabled) {\n  background: rgba(0, 0, 0, 0.8);\n  transform: scale(1.1);\n}\n\n.gallery-nav:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.gallery-image-wrapper {\n  position: relative;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.gallery-image {\n  max-width: 100%;\n  max-height: 70vh;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.image-counter {\n  position: absolute;\n  bottom: -30px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 14px;\n}\n\n.thumbnail-container {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 50px;\n  padding: 10px;\n  overflow-x: auto;\n}\n\n.thumbnail {\n  width: 60px;\n  height: 60px;\n  object-fit: cover;\n  border-radius: 6px;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: all 0.3s;\n}\n\n.thumbnail:hover {\n  transform: scale(1.05);\n  border-color: #007bff;\n}\n\n.thumbnail.active {\n  border-color: #007bff;\n  box-shadow: 0 0 10px rgba(0, 123, 255, 0.5);\n}\n\n/* For better mobile responsiveness */\n@media (max-width: 768px) {\n  .gallery-nav {\n    width: 35px;\n    height: 35px;\n  }\n  \n  .gallery-nav svg {\n    width: 24px;\n    height: 24px;\n  }\n  \n  .thumbnail {\n    width: 45px;\n    height: 45px;\n  }\n  \n  .gallery-content {\n    padding: 15px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
